var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faChevronDown, faEdit, faSave } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Icon, Input, Row, Select, Typography } from "antd";
import Form from "antd/lib/form/Form";
import React from "react";
var EditInput = /** @class */ (function (_super) {
    __extends(EditInput, _super);
    function EditInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editClicked: false,
            edited: false,
            unit: _this.props.unit
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            if (prevProps.options.initialValue !== _this.props.options.initialValue) {
                _this.setState({
                    edited: false
                });
            }
        };
        _this.render = function () {
            var _a = _this.props, fieldKey = _a.fieldKey, options = _a.options, onChange = _a.onChange, placeholder = _a.placeholder, disabled = _a.disabled;
            var _b = _this.state, editClicked = _b.editClicked, edited = _b.edited, unit = _b.unit;
            var _c = _this.props.form, getFieldDecorator = _c.getFieldDecorator, getFieldValue = _c.getFieldValue, getFieldError = _c.getFieldError;
            var hasError = getFieldError(fieldKey);
            return (React.createElement(Row, null,
                React.createElement(Col, { xxl: 22, xl: 22, lg: 22, md: 22, sm: 24, xs: 24 }, editClicked ?
                    React.createElement(Form.Item, null, getFieldDecorator(fieldKey, __assign({}, options))(React.createElement(Input, { placeholder: placeholder, disabled: disabled, onChange: function () { return !edited && _this.setState({ edited: true }); }, addonAfter: React.createElement(Select, { suffixIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faChevronDown }); } }), defaultValue: unit || "minutes", style: { width: 90 }, onChange: function (value) { return _this.setState({ unit: value }); } },
                            React.createElement(Select.Option, { key: 1, value: "minutes" }, "Minutes"),
                            React.createElement(Select.Option, { key: 2, value: "hours" }, "Hours"),
                            React.createElement(Select.Option, { key: 2, value: "other" }, "Other")), onPressEnter: function (e) {
                            if (!disabled && !hasError) {
                                _this.setState({ editClicked: false });
                                var value = e.currentTarget.value;
                                if (value !== options.initialValue) {
                                    onChange("".concat(value).concat(unit !== "other" ? " ".concat(unit) : ""));
                                }
                            }
                        } }))) :
                    React.createElement(Typography.Paragraph, { ellipsis: true }, edited ? "".concat(getFieldValue(fieldKey)).concat(unit !== "other" ? " ".concat(unit) : "") || "N/A" : "".concat(options.initialValue).concat(unit !== "other" ? " ".concat(unit) : "") || "N/A")),
                React.createElement(Col, { xxl: 2, xl: 2, lg: 2, md: 2, sm: 24, xs: 24 }, editClicked ?
                    React.createElement(Form.Item, null,
                        React.createElement(Icon, { className: "margin-left-xs ".concat(disabled || hasError ? "color-gray-5" : "color-blue-5 cursor-pointer", " font-size-lg"), component: function () { return React.createElement(FontAwesomeIcon, { icon: faSave }); }, onClick: function () {
                                if (!disabled && !hasError) {
                                    _this.setState({ editClicked: false });
                                    var value = getFieldValue(fieldKey);
                                    if (value !== options.initialValue) {
                                        onChange("".concat(getFieldValue(fieldKey)).concat(unit !== "other" ? " ".concat(unit) : ""));
                                    }
                                }
                            } })) :
                    React.createElement(Icon, { className: "margin-left-xs ".concat(disabled ? "color-gray-5" : "color-blue-5 cursor-pointer", " font-size-lg"), component: function () { return React.createElement(FontAwesomeIcon, { icon: faEdit }); }, onClick: function () {
                            if (!disabled) {
                                _this.setState({ editClicked: true });
                            }
                        } }))));
        };
        return _this;
    }
    return EditInput;
}(React.Component));
export default EditInput;
//# sourceMappingURL=edit-time-view.js.map